import { DashboardBaseFilterModel } from '@/dashboard/models/DashboardBaseFilterModel'

export class DashboardSalesPeakFilterModel extends DashboardBaseFilterModel {
    constructor(d?:Partial<DashboardSalesPeakFilterModel>) {
        super(d)
    }
}
